module.exports = require('./dist/animation/animation.js');
